import type { CategoryGlyphIcon } from '@/shared/lib/category-icon';
import { joinCss } from '@/shared/lib/css-utils';
import css from './map-icon-glyph.module.scss';

// Dark circular category badge — legacy-map parity: a 30px slate circle
// (`bg-slate-700 p-1`) whose 22px white glyph fills the padded box, no ring
// or shadow. Rendered to static HTML via `renderToStaticMarkup` inside
// `buildMapIcon`, so it must stay free of event handlers / refs. The module
// SCSS loads transitively (bundled when `build-map-icon` is imported) so the
// hashed classes resolve in the DOM.
export type MapIconGlyphProps = {
  Icon: CategoryGlyphIcon;
  color: string;
  // Stroke weight the legacy asset baked in (the ported legacy icons ignore
  // it and use their own).
  strokeWidth: number;
  /** Singled out (e.g. its row hovered in a list): bigger, pulsing. */
  highlighted?: boolean;
};

export const MapIconGlyph = ({
  Icon,
  color,
  strokeWidth,
  highlighted = false,
}: MapIconGlyphProps) => (
  <div
    className={joinCss(css.root, highlighted && css.rootIsHighlighted)}
    style={{ backgroundColor: color }}
  >
    <Icon size={22} strokeWidth={strokeWidth} />
  </div>
);
